import React, { useRef } from 'react';
import { WindowSize } from '../models/common/windowSize';

export function useWindowSize(): WindowSize {
  const isSSR = typeof window === 'undefined';
  const windowSize = useRef<any>();
  windowSize.current = {
    width: isSSR ? 1200 : window.innerWidth,
    height: isSSR ? 800 : window.innerHeight,
  };

  function changeWindowSize() {
    if (windowSize.current)
      windowSize.current = { width: window.innerWidth, height: window.innerHeight };
  }

  React.useEffect(() => {
    changeWindowSize();
    window.addEventListener('resize', changeWindowSize);

    return () => {
      window.removeEventListener('resize', changeWindowSize);
    };
  }, []);

  return windowSize.current;
}

export const useIsMobileScreen = (): boolean => {
  const windowSize = useWindowSize();

  return windowSize.width < 768;
};
